import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { LabelingState } from '@/stores/slices/Labeling/types'
import { getUserClasses, updateClassOrder } from '@/stores/slices/Labeling/thunks/class'

export const classExtraReducers = (builder: ActionReducerMapBuilder<LabelingState>) => {
  builder.addCase(getUserClasses.fulfilled, (state, action) => {
    state.classes = action.payload
  })
  builder.addCase(updateClassOrder.fulfilled, (state, action) => {
    state.classes = action.payload
  })
}
